// @ts-ignore
export const all = (state) => state.all;

// @ts-ignore
export const assorted = (state) => {
  const members: any = {};
  state.all.forEach((member: any) => {
    members[member.id] = member;
  });

  return members;
};

export const sorted = (state: any) => state.all.sort((a: any, b: any) => {
  if (a.title.toLowerCase() > b.title.toLowerCase()) {
    return 1;
  }
  if (b.title.toLowerCase() > a.title.toLowerCase()) {
    return -1;
  }

  return 0;
});
